module.exports = __webpack_public_path__ + "img/elementlengths_jas.aed759c6.png";